import { render, staticRenderFns } from "./TransferSerial.vue?vue&type=template&id=0ac9b5f6&scoped=true&"
import script from "./TransferSerial.vue?vue&type=script&lang=ts&"
export * from "./TransferSerial.vue?vue&type=script&lang=ts&"
import style0 from "./TransferSerial.vue?vue&type=style&index=0&id=0ac9b5f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac9b5f6",
  null
  
)

export default component.exports